import { StylesConfig } from "react-select";
import { colorBg, colorMain } from "./colors";

type CarOptionStyle = {
  label: string;
  value: string;
  power: number;
  consumption: number;
  img: string;
};

type IsMulti = false;

export const selectStyle: StylesConfig<CarOptionStyle, IsMulti> = {
  control: (provided) => {
    return {
      ...provided,
      color: colorMain,
      fontWeight: "600",
      border: `3px solid ${colorMain}`,
      borderRadius: "8px",
      boxShadow: "none",
      cursor: "pointer",
      "&:hover": {
        borderColor: colorMain,
      },
    };
  },
  placeholder: (provided) => {
    return { ...provided, color: colorMain };
  },
  dropdownIndicator: (provided) => {
    return { ...provided, color: colorMain };
  },
  indicatorSeparator: (provided) => {
    return { ...provided, backgroundColor: colorMain, width: "2px" };
  },
  option: (provided, current) => {
    return {
      ...provided,
      color: current.isFocused ? colorBg : colorMain,
      backgroundColor: current.isFocused ? colorMain : colorBg,
      fontWeight: current.isSelected ? "bold" : "normal",
      cursor: "pointer",
      ":active": {
        backgroundColor: colorMain,
      },
    };
  },
  singleValue: (provided) => {
    return { ...provided, color: colorMain };
  },
};
